import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";

export const loginAdmin = (FormData, navigate, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post("/admin/auth/login", FormData, {
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => {
      if (res.data.message === "Login successful") {
        toast.success(res.data.message);
        secureStorage.setItem("adminToken", res.data.token);
        secureStorage.setItem("admin", JSON.stringify(res.data.user));
        window.location.replace("/admin/dashboard");
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
        setIsLoading(false);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      setIsLoading(false);
    });
};
